'use client';

import { motion } from 'framer-motion';
import Image from 'next/image';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <Image
        src="/hero-background.png"
        alt=""
        fill
        priority
        sizes="100vw"
        className="object-cover"
      />

      {/* Tint over the image for brand harmony */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(135deg, rgba(26,42,32,0.75) 0%, rgba(42,66,48,0.55) 45%, rgba(58,90,64,0.45) 80%, rgba(90,138,98,0.35) 100%)',
        }}
      />

      {/* Decorative bokeh blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-32 -right-32 w-[600px] h-[600px] rounded-full opacity-20 blur-3xl"
          style={{ background: 'radial-gradient(circle, #5a8a62, transparent)' }}
        />
        <div
          className="absolute -bottom-24 -left-24 w-[500px] h-[500px] rounded-full opacity-15 blur-3xl"
          style={{ background: 'radial-gradient(circle, #c5dbc8, transparent)' }}
        />
      </div>

      {/* Subtle vignette overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/50" />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-sans text-cream-200/65 tracking-[0.3em] uppercase text-xs mb-7"
        >
          Bien-être &nbsp;&bull;&nbsp; Sérénité &nbsp;&bull;&nbsp; Harmonie
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
          className="font-serif text-cream-100 text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-[1.1] mb-6"
        >
          La Canopée
          <br />
          <em className="font-light">de Christelle</em>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="font-sans text-cream-100/65 text-lg md:text-xl leading-relaxed mb-10 max-w-lg mx-auto"
        >
          Un espace dédié à votre bien-être, où chaque soin est une invitation
          au lâcher-prise.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 1.1 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            href="#booking"
            className="bg-cream-100 text-forest-dark font-sans px-8 py-3.5 rounded-full hover:bg-cream-50 transition-colors tracking-wide text-sm"
          >
            Réserver une séance
          </a>
          <a
            href="#services"
            className="border border-cream-100/40 text-cream-100 font-sans px-8 py-3.5 rounded-full hover:bg-cream-100/10 transition-colors tracking-wide text-sm"
          >
            Découvrir nos soins
          </a>
        </motion.div>
      </div>

    </section>
  );
}
